module.exports = __webpack_public_path__ + "static/media/location.bd4a10f9.svg";